/**
 * Content approval registry.
 *
 * Every public copy block is registered here. Anything not 'approved' shows a
 * discreet "Draft content — pending approval" marker in development/staging
 * (VITE_SHOW_CONTENT_STATUS) so stakeholders can review it. Production hides
 * markers, so ONLY approve a block after the business has signed off its text.
 */
export type ContentState = 'draft' | 'approved';

export const CONTENT_STATUS = {
  'home.hero': 'draft',
  'home.sun': 'draft',
  'home.film': 'draft',
  'home.protection': 'draft',
  'home.original': 'draft',
  'home.choose': 'draft',
  'home.films': 'draft',
  'home.network': 'draft',
  'landing.services': 'draft',
  'landing.book': 'draft',
  'landing.contact': 'draft',
  'page.warranty': 'draft',
  'page.contact': 'draft',
  'page.authenticity': 'draft',
  'page.story': 'draft',
  'page.films': 'draft',
  'page.filmFamily': 'draft',
  'page.privacy': 'draft',
  'page.credits': 'draft',
} as const satisfies Record<string, ContentState>;

export type ContentSection = keyof typeof CONTENT_STATUS;

export function isApproved(section: ContentSection): boolean {
  // Read through the widened type: while every block is still 'draft', the
  // literal types would make an 'approved' comparison look impossible to tsc.
  const status: Readonly<Record<ContentSection, ContentState>> = CONTENT_STATUS;
  return status[section] === 'approved';
}
